import { usePal, PalHead, PalIcon, SubHead } from "./PalUI";

const Phase = ({ p, testid }) => {
  const { brand, ink, muted, surface } = usePal();
  return (
    <div className={`rounded-2xl border p-5 h-full flex-1 ${surface}`} data-testid={testid}>
      <div className="flex items-center justify-between">
        <PalIcon name={p.iconName} className="w-5 h-5" style={{ color: brand }} />
        <span className="text-[13px] font-semibold tabular-nums px-2.5 py-1 rounded-full" style={{ backgroundColor: `${brand}22`, color: brand }}>{p.days}</span>
      </div>
      <h3 className={`mt-3 text-[17px] font-semibold tracking-tight ${ink}`}>{p.title}</h3>
      <ul className="mt-3 space-y-1.5">
        {p.items.map((it) => (
          <li key={it} className={`flex gap-2 text-[13.5px] leading-snug ${muted}`}>
            <span className="mt-[7px] w-1 h-1 rounded-full flex-shrink-0" style={{ backgroundColor: brand }} />{it}
          </li>
        ))}
      </ul>
    </div>
  );
};

const PalMetadata = () => {
  const { c, brand, ink, hair } = usePal();
  const m = c.metadata;
  const [setup, processing, dryrun] = m.phases;
  return (
    <section aria-label={m.eyebrow} data-testid="pal-metadata">
      <PalHead eyebrow={m.eyebrow} title={m.title} accentLine={m.accentLine} />
      <div className={`mt-8 pt-6 border-t grid grid-cols-1 lg:grid-cols-[2fr_auto_1fr] gap-4 ${hair}`}>
        <div className="flex flex-col">
          <div className="flex items-center gap-3 mb-3 h-5" data-testid="pal-metadata-window">
            <span className="h-px flex-1" style={{ backgroundColor: brand }} />
            <span className="text-[12px] font-semibold uppercase tracking-wider" style={{ color: brand }}>{m.windowLabel}</span>
            <span className="h-px flex-1" style={{ backgroundColor: brand }} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1.4fr] gap-4 flex-1">
            <Phase p={setup} testid="pal-metadata-phase-0" />
            <Phase p={processing} testid="pal-metadata-phase-1" />
          </div>
        </div>
        <div className="flex lg:flex-col items-center justify-center gap-2 px-1 lg:pt-8" data-testid="pal-metadata-submission">
          <span className="w-3 h-3 rounded-full" style={{ backgroundColor: brand }} />
          <span className={`text-[11px] font-semibold text-center max-w-[130px] leading-snug ${ink}`}>{m.submissionLabel}</span>
        </div>
        <div className="flex flex-col">
          <div className="mb-3 h-5" aria-hidden="true" />
          <Phase p={dryrun} testid="pal-metadata-phase-2" />
        </div>
      </div>
      <div className="mt-6 flex flex-wrap items-center gap-2" data-testid="pal-metadata-dependencies">
        <SubHead>{m.dependenciesLabel}</SubHead>
        {m.dependencies.map((x) => (
          <span key={x} className={`ml-1 text-[13px] px-3 py-1.5 rounded-full border ${hair} ${ink}`}>{x}</span>
        ))}
      </div>
      <p className={`mt-6 text-[18px] font-semibold tracking-tight lg:whitespace-nowrap ${ink}`} data-testid="pal-metadata-takeaway">{m.takeaway}</p>
    </section>
  );
};

export default PalMetadata;
